import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/** メインメニュー表示アクションクリエータ */
export const openMainMenu = actionCreator<{
	isOpen: boolean;
}>('OPEN_MAIN_MENU');

/** メインメニュー項目設定アクションクリエータ */
export const setMainMenuItems = actionCreator<{
	items: string[];
}>('SET_MAIN_MENU_ITEMS');

/** TSQウィンドウ設定アクションクリエータ */
export const setTsqWindow = actionCreator<{
	tsqWindow: Window | null;
}>('SET_TSQ_WINDOW');



// WEBPACK FOOTER //
// ./src/actions/mainMenu.ts